export const emiScrollHelper = (id: string, scrollableContainerClass: string) => {
	setTimeout(() => {
		const element = document.getElementById(id);
		if (element) {
			const offset = 100; // 100px from the top
			const elementPosition = element.getBoundingClientRect().top;
			const offsetPosition = elementPosition - offset;
			const scrollableContainer = document.querySelector(scrollableContainerClass);
			if (scrollableContainer) {
				scrollableContainer.scrollBy({
					top: offsetPosition,
					behavior: 'smooth',
				});
			}
		}
	}, 200); // Small delay to ensure the DOM has updated
};
